export interface MegaMenuGroup {
  heading: string;
  headingPath?: string;
  items: Array<{
    label: string;
    path: string;
    badge?: string;
  }>;
}

export interface CategoryDockItem {
  slug: string;
  name: string;
  shortDesc: string;
  path: string;
  icon: string;
  subItems?: Array<{ label: string; path: string; badge?: string }>;
  megaColumns?: MegaMenuGroup[][];
  megaBanner?: {
    image: string;
    alt: string;
    path: string;
  };
}

export interface WoodmartCategoryCard {
  name: string;
  countLabel: string;
  image: string;
  path: string;
}

export interface PricingPlan {
  id: string;
  name: string;
  badge: string;
  price: string;
  unit: string;
  subtitle: string;
  popular?: boolean;
  features: string[];
  ctaLabel: string;
  ctaPath: string;
}

export interface ComparisonRow {
  criterion: string;
  ecampmcs: string;
  others: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteConfig = {
  domain: 'pmcstech.net' as const,
  baseUrl: 'https://pmcstech.net',
  companyName: 'PMCS TECH',
  legalName: 'CÔNG TY TNHH PMCS TECH',
  englishName: 'PMCS TECH COMPANY LIMITED',
  taxId: '0315773444',
  foundingDate: '2019-07-05',
  operatingSince: '05/07/2019',
  logoUrl: '/wp-content/uploads/2025/02/LOGO-1-300x112.png',
  footerLogoUrl: '/wp-content/uploads/2022/12/Logo-pmcs-1-300x86.png',
  ecamIconUrl: '/wp-content/uploads/2025/02/phan-mem-quay-video-dong-goi-hang-hoa-ecampmcs-4-150x150.png',
  tagline: 'Phần Mềm Quay Video Đóng Hàng ECAMPMCS, Thiết Bị Mã Vạch & Quà Tặng Công Nghệ',
  heroBadge: 'GIẢI PHÁP QUAY VIDEO ĐÓNG HÀNG & THIẾT BỊ MÃ VẠCH CHÍNH HÃNG',
  phoneDisplay: '0911.338.893',
  phoneIntl: '+84.911338893',
  phoneRaw: '0911338893',
  phoneHref: 'tel:0911338893',
  techPhoneDisplay: '0969.678.988',
  techPhoneHref: 'tel:0969678988',
  zaloUrl: 'https://zalo.me/0911338893',
  email: 'Sales@pmcstech.com',
  youtubeUrl: 'https://www.youtube.com/@pmcstech-mayquetmavach5105',
  sisterDomainUrl: 'https://pmcstech.com',
  sisterDomainLabel: 'Chuyên trang Thiết bị RFID: pmcstech.com',
  workingHours: 'Thứ 2 – Thứ 6: 08:00 – 17:00 | Thứ 7: 08:00 – 12:00',
  address: {
    street: 'Tầng 19, Khu A - Khu Văn Phòng, Tòa Nhà Indochina Park Tower, Số 4 Nguyễn Đình Chiểu',
    ward: 'Phường Đa Kao',
    district: 'Quận 1',
    city: 'TP. Hồ Chí Minh',
    country: 'VN',
    postalCode: '700000',
    full: 'Tầng 19, Khu A - Khu Văn Phòng, Tòa Nhà Indochina Park Tower, Số 4 Nguyễn Đình Chiểu, Phường Đa Kao, Quận 1, TP. Hồ Chí Minh',
    demoRoom: 'Đường 14, Khu Đô Thị Vạn Phúc, Phường Hiệp Bình Phước, TP. Thủ Đức, TP. Hồ Chí Minh',
    lat: '10.7918056',
    lng: '106.7000374',
    mapUrl: 'https://www.google.com/maps/place/PMCS+TECH+CO.,+LTD/@10.7918056,106.7000374,17z'
  },
  author: {
    name: 'Đội ngũ Kỹ sư PMCS TECH',
    role: 'Chuyên gia Giải pháp Quay Video Đóng Hàng ECAMPMCS, RFID & Mã Vạch',
    credentials: 'Nhà phân phối ủy quyền OPTICON & CHAINWAY tại Việt Nam — Triển khai thực tế cho Trung Nguyên Legend và hàng trăm kho vận TMĐT'
  },
  primaryLinks: [
    { label: 'Home', mobileLabel: 'Home', path: '/' },
    { label: 'Phần Mềm quay video đóng hàng', mobileLabel: 'ECAMPMCS', path: '/product/phan-mem-quay-video-dong-hang-ecampmcs/' },
    { label: 'Bài Viết – Tin Tức', mobileLabel: 'Tin Tức', path: '/bai-viet-tin-tuc/' },
    { label: 'Download', mobileLabel: 'Download', path: '/download/' },
    { label: 'Liên Hệ', mobileLabel: 'Liên Hệ', path: '/lien-he/' }
  ]
};

// Exact 9 WoodMart Sticky Left Rail Items (#menu-sticky-navigation-mega-electronics)
export const categoryDockItems: CategoryDockItem[] = [
  {
    slug: 'may-quet-ma-vach',
    name: 'Máy Quét Mã Vạch',
    shortDesc: 'Opticon 1D/2D chính hãng',
    path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/',
    icon: '/wp-content/uploads/2025/02/Icon-barcode-scanner.svg',
    subItems: [
      { label: 'Máy Quét Mã Vạch Có Dây', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-co-day/' },
      { label: 'Máy Quét Mã Vạch Không Dây', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-khong-day/' },
      { label: 'Máy Quét Mã Vạch Băng Chuyền', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-bang-chuyen/' },
      { label: 'Máy Kiểm Kho PDA', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' }
    ],
    megaColumns: [
      [
        {
          heading: 'THEO HÌNH THỨC',
          headingPath: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/',
          items: [
            { label: 'Máy Quét Mã Vạch Có Dây', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-co-day/' },
            { label: 'Máy Quét Mã Vạch Không Dây', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-khong-day/' },
            { label: 'Máy Quét Mã Vạch Băng Chuyền', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/may-quet-ma-vach-bang-chuyen/' },
            { label: 'Máy Quét Mã QR CCCD/ hộ chiếu/ BHYT', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Đeo Tay', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' }
          ]
        },
        {
          heading: 'LOẠI TIA QUÉT',
          headingPath: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/',
          items: [
            { label: 'Máy Quét Mã Vạch 1D (Laser)', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch 1D (CCD)', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch 2D', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Đa Tia', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch UV', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/', badge: 'Special' }
          ]
        },
        {
          heading: 'MÁY KIỂM KHO',
          headingPath: '/product-category/thiet-bi-ma-vach/may-kiem-kho/',
          items: [
            { label: 'Máy Kiểm Kho Android', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' },
            { label: 'Máy Kiểm Kho Windows Mobile', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' },
            { label: 'Máy Kiểm Kho Windows CE', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' },
            { label: 'Máy Kiểm Kho Thu Thập Dữ Liệu', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' }
          ]
        }
      ],
      [
        {
          heading: 'THEO THƯƠNG HIỆU',
          headingPath: '/thuong-hieu/',
          items: [
            { label: 'Máy Quét Mã Vạch OPTICON', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Zebra', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Honeywell', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Chainway', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' },
            { label: 'Máy Quét Mã Vạch Datalogic', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Cipherlab', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Newland', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' },
            { label: 'Máy Quét Mã Vạch Unitech', path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/' }
          ]
        },
        {
          heading: 'PHỤ KIỆN MÁY QUÉT MÃ VẠCH',
          headingPath: '/product-category/thiet-bi-ma-vach/',
          items: [
            { label: 'Chân Đế Máy Quét Mã Vạch', path: '/product-category/thiet-bi-ma-vach/' },
            { label: 'Đế Sạc Máy Quét Mã Vạch', path: '/product-category/thiet-bi-ma-vach/' },
            { label: 'Pin Máy Quét Mã Vạch', path: '/product-category/thiet-bi-ma-vach/' },
            { label: 'Tay Cầm Máy Kiểm Kho', path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/' }
          ]
        }
      ]
    ],
    megaBanner: {
      image: '/wp-content/uploads/2022/12/Chainway-C66-2-183x300.png',
      alt: 'Máy kiểm kho Chainway C66 Android 11',
      path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/'
    }
  },
  {
    slug: 'may-in-ma-vach',
    name: 'Máy In Mã Vạch',
    shortDesc: 'Máy in tem nhãn & đơn TMĐT',
    path: '/product-category/thiet-bi-ma-vach/',
    icon: '/wp-content/uploads/2025/02/Icon-barcode-printer.svg'
  },
  {
    slug: 'giay-in-ma-vach',
    name: 'Giấy In Mã Vạch',
    shortDesc: 'Decal nhiệt & Mực in Ribbon',
    path: '/product-category/thiet-bi-ma-vach/',
    icon: '/wp-content/uploads/2025/02/Icon-label.svg'
  },
  {
    slug: 'may-doc-rfid',
    name: 'Máy Đọc RFID',
    shortDesc: 'Đầu đọc UHF RFID cố định & PDA',
    path: '/cong-nghe-rfid/',
    icon: '/wp-content/uploads/2025/02/Icon-may-doc-rfid.svg'
  },
  {
    slug: 'may-in-rfid',
    name: 'Máy in RFID',
    shortDesc: 'In & Mã hóa chip UHF RFID',
    path: '/cong-nghe-rfid/',
    icon: '/wp-content/uploads/2025/02/Icon-may-in-rfid.svg'
  },
  {
    slug: 'tem-nhan-rfid',
    name: 'Tem Nhãn RFID',
    shortDesc: 'Thẻ UHF RFID kho vận & nữ trang',
    path: '/cong-nghe-rfid/',
    icon: '/wp-content/uploads/2025/02/Icon-tem-nhan-rfid.svg'
  },
  {
    slug: 'phu-kien-cong-nghe',
    name: 'Phụ Kiện Công Nghệ',
    shortDesc: 'Quà tặng khắc Logo LED phát sáng',
    path: '/product-category/phu-kien-cong-nghe/',
    icon: '/wp-content/uploads/2025/02/Icon-consumer-electronic.svg',
    subItems: [
      { label: 'Led Logo', path: '/product-category/phu-kien-cong-nghe/led-logo/' },
      { label: 'Set Quà Tặng Công Nghệ', path: '/product-category/phu-kien-cong-nghe/set-qua-tang-cong-nghe/' },
      { label: 'Loa Bluetooth', path: '/product-category/phu-kien-cong-nghe/loa-bluetooth/' },
      { label: 'Sạc Không Dây', path: '/product-category/phu-kien-cong-nghe/sac-khong-day/' },
      { label: 'Sạc Dự Phòng', path: '/product-category/phu-kien-cong-nghe/sac-du-phong/' },
      { label: 'Tai Nghe Bluetooth', path: '/product-category/phu-kien-cong-nghe/tai-nghe-bluetooth/' },
      { label: 'Phụ Kiện Công Nghệ Khác', path: '/product-category/phu-kien-cong-nghe/phu-kien-cong-nghe-khac/' }
    ]
  },
  {
    slug: 'camera-dong-hang',
    name: 'Camera',
    shortDesc: 'Camera soi mã vận đơn & Toàn cảnh',
    path: '/2025/08/22/camera-quay-video-dong-hang/',
    icon: '/wp-content/uploads/2025/02/Icon-camera.svg'
  },
  {
    slug: 'phan-mem-ecampmcs',
    name: 'Phần Mềm',
    shortDesc: 'Quay video đóng gói hàng hóa',
    path: '/product/phan-mem-quay-video-dong-hang-ecampmcs/',
    icon: '/wp-content/uploads/2025/02/Icon-Software.svg'
  }
];

// Section 3 on Homepage: THIẾT BỊ MÃ VẠCH & RFID (6 WoodMart Category Cards)
export const barcodeRfidCategories: WoodmartCategoryCard[] = [
  {
    name: 'Máy Quét Mã Vạch',
    countLabel: '35 sản phẩm',
    image: '/wp-content/uploads/2025/02/may-quet-ma-vach-banner-001-300x300.png',
    path: '/product-category/thiet-bi-ma-vach/may-quet-ma-vach/'
  },
  {
    name: 'Máy In Mã Vạch',
    countLabel: 'Zebra • Sato',
    image: '/wp-content/uploads/2025/02/may-in-ma-vach-zebra-300x300.png',
    path: '/product-category/thiet-bi-ma-vach/'
  },
  {
    name: 'Giấy In Mã Vạch',
    countLabel: 'Decal & Ribbon',
    image: '/wp-content/uploads/2025/02/giay-in-ma-vach-001-300x300.png',
    path: '/product-category/thiet-bi-ma-vach/'
  },
  {
    name: 'Tem Nhãn RFID',
    countLabel: 'UHF / NFC Tag',
    image: '/wp-content/uploads/2025/02/tem-nhan-rfid-001-300x300.png',
    path: '/cong-nghe-rfid/'
  },
  {
    name: 'Máy In RFID',
    countLabel: 'Công nghiệp',
    image: '/wp-content/uploads/2025/02/may-in-tem-nhan-ma-vach-zebra-zt-300x300.png',
    path: '/cong-nghe-rfid/'
  },
  {
    name: 'Máy Đọc RFID',
    countLabel: 'Chainway • Zebra',
    image: '/wp-content/uploads/2025/02/may-doc-the-rfid-001-300x300.png',
    path: '/cong-nghe-rfid/'
  }
];

// Section 4 on Homepage: PHỤ KIỆN CÔNG NGHỆ (6 WoodMart Category Cards)
export const techAccessoryCategories: WoodmartCategoryCard[] = [
  {
    name: 'Loa Bluetooth',
    countLabel: '22 sản phẩm',
    image: '/wp-content/uploads/2025/02/loa-bluetooth-den-led-kiem-de-sac-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/loa-bluetooth/'
  },
  {
    name: 'Set Quà Tặng Công Nghệ',
    countLabel: '16 sản phẩm',
    image: '/wp-content/uploads/2025/02/set-qua-tang-cong-nghe-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/set-qua-tang-cong-nghe/'
  },
  {
    name: 'Sạc Không Dây',
    countLabel: '19 sản phẩm',
    image: '/wp-content/uploads/2025/02/de-sac-khong-day-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/sac-khong-day/'
  },
  {
    name: 'Tai Nghe Bluetooth',
    countLabel: 'Âm thanh HD',
    image: '/wp-content/uploads/2025/02/ta-nghe-chup-tai-bluetooth-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/tai-nghe-bluetooth/'
  },
  {
    name: 'Phụ Kiện Công Nghệ Khác',
    countLabel: 'USB & Cáp LED',
    image: '/wp-content/uploads/2025/02/phu-kien-cong-nghe-002-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/phu-kien-cong-nghe-khac/'
  },
  {
    name: 'Sạc Dự Phòng',
    countLabel: '13 sản phẩm',
    image: '/wp-content/uploads/2025/02/sac-du-phong-logo-led-300x300.png',
    path: '/product-category/phu-kien-cong-nghe/sac-du-phong/'
  }
];

export const ecampmcsPricingPlans: PricingPlan[] = [
  {
    id: 'standard-1-table',
    name: 'ECAMPMCS — Gói 1 Bàn Đóng Hàng',
    badge: 'CHỈ 3 TRIỆU CHO 1 BÀN ĐÓNG HÀNG',
    price: '3.000.000 ₫',
    unit: 'Tính theo đầu máy tính (12 tháng / 1 PC) • Quy mô: 1 bàn đóng hàng',
    subtitle: 'Dành cho shop TMĐT triển khai 1 bàn quay video đóng hàng (1–2 camera) trên 1 máy tính — không giới hạn số video, thời lượng video và thời hạn lưu.',
    popular: false,
    features: [
      'Kết nối 1 bàn quay video đóng hàng (1 camera toàn cảnh + 1 camera soi mã vận đơn)',
      'Giá phần mềm tính theo đầu máy tính (12 tháng / 1 PC)',
      'Không giới hạn số lượng video, thời lượng video & thời hạn lưu trữ',
      'Hỗ trợ cả máy quét mã vạch 2D rời và nhận diện AI QR trực tiếp qua camera',
      'Tự động đóng dấu Mã đơn hàng & Thời gian thực (Timestamp) lên video',
      'Tra cứu video đơn hàng nhanh chóng theo mã vận đơn & chia sẻ link CDN miễn phí'
    ],
    ctaLabel: 'Đăng Ký Gói 1 Bàn (3.000.000 ₫)',
    ctaPath: '/product/phan-mem-quay-video-dong-hang-ecampmcs/'
  },
  {
    id: 'multi-table-pro',
    name: 'ECAM Extend — Gói Từ 2 Bàn Trở Lên',
    badge: 'ĐƯỢC CHỌN NHIỀU NHẤT',
    price: '5.000.000 ₫',
    unit: 'Tính theo đầu máy tính (12 tháng / 1 PC) • Quy mô: Từ 2 bàn trở lên (Không giới hạn số bàn)',
    subtitle: 'Khi triển khai từ 2 bàn trở lên — Giá phần mềm tính theo đầu máy tính, mỗi máy tính KHÔNG GIỚI HẠN số bàn đóng gói / số video / thời lượng video / thời hạn lưu.',
    popular: true,
    features: [
      'Mỗi máy tính KHÔNG GIỚI HẠN số bàn đóng gói (phụ thuộc cấu hình phần cứng PC)',
      'Không giới hạn số lượng video, không giới hạn thời lượng video & thời hạn lưu trữ',
      'Tích hợp máy quét mã vạch 2D Opticon (cấu hình Suffix) & AI ROI soi mã vận đơn',
      'Cảnh báo tức thì khi quét trùng mã vận đơn hoặc đơn hủy (Duplicate/Aborted Alert)',
      'Quản lý nhân viên bằng thẻ QR, phân quyền RBAC & bảng xếp hạng KPI đóng gói',
      'Hỗ trợ chia sẻ video hàng loạt lên Public Cloud & liên kết đa kho P2P Mesh'
    ],
    ctaLabel: 'Đăng Ký Gói Từ 2 Bàn (5.000.000 ₫)',
    ctaPath: '/product/phan-mem-quay-video-dong-hang-ecampmcs/'
  },
  {
    id: 'hardware-combo',
    name: 'Combo Thiết Bị Cho 1 Bàn Đóng Hàng',
    badge: 'TRỌN BỘ PHẦN CỨNG CHÍNH HÃNG',
    price: 'Liên hệ báo giá',
    unit: 'Miễn phí lắp đặt TP.HCM khi triển khai trên 3 bàn đóng hàng',
    subtitle: 'Giải pháp phần cứng đồng bộ chuyên dụng cho trạm đóng gói tiêu chuẩn sàn TMĐT.',
    popular: false,
    features: [
      '01 Cái Camera toàn cảnh (Ghi lại toàn bộ quá trình đóng hàng từ góc rộng)',
      '01 Cái Camera soi mã vận đơn (Ghi rõ nét thông tin phiếu vận đơn chuẩn sàn)',
      '01 Bộ giá treo di động 2 camera (Giá gắn linh hoạt, dễ điều chỉnh vị trí quay)',
      '01 Cái Màn hình tín hiệu (Thể hiện trạng thái đang ghi hình / ngừng ghi hình)',
      'Tùy chọn mua lẻ từng thiết bị hoặc trang bị thêm máy quét Opticon 2D',
      'Bảo hành chính hãng theo tiêu chuẩn nhà sản xuất, hỗ trợ kỹ thuật 1-1'
    ],
    ctaLabel: 'Nhận Báo Giá Combo Thiết Bị',
    ctaPath: '/lien-he/'
  }
];

export const ecampmcsComparisonRows: ComparisonRow[] = [
  {
    criterion: '1. Bảo mật dữ liệu video',
    ecampmcs: 'Không thu thập, không gửi dữ liệu đi; lưu cục bộ 100% tại PC khách hàng',
    others: 'Lưu trữ trên server bên thứ ba, tiềm ẩn rủi ro lộ thông tin đơn hàng'
  },
  {
    criterion: '2. Chia sẻ video đối soát khiếu nại',
    ecampmcs: 'Chia sẻ qua CDN miễn phí, mã hóa an toàn và tạo link rút gọn tức thì',
    others: 'Yêu cầu tải file thủ công nặng nề hoặc link chia sẻ thiếu bảo mật'
  },
  {
    criterion: '3. Tìm kiếm & Truy xuất video',
    ecampmcs: 'Tìm kiếm theo mã vận đơn trên toàn hệ thống, chính xác trong 3 giây',
    others: 'Tìm kiếm thủ công theo thư mục hoặc dò tìm theo ngày giờ mất thời gian'
  },
  {
    criterion: '4. Số bàn đóng gói & Camera hỗ trợ trên 1 PC',
    ecampmcs: 'Không giới hạn số bàn đóng gói trên 1 máy tính (phụ thuộc cấu hình phần cứng PC)',
    others: 'Hạn chế chỉ từ 1 – 2 bàn (2 – 4 Camera) trên mỗi máy tính'
  },
  {
    criterion: '5. Mở rộng số lượng bàn đóng hàng',
    ecampmcs: 'Dễ dàng mở rộng thêm bàn đóng hàng mà không phải mua thêm máy tính',
    others: 'Mỗi bàn đóng hàng bắt buộc phải trang bị 1 bộ máy tính riêng'
  },
  {
    criterion: '6. Cảnh báo đơn hàng quét trùng lặp',
    ecampmcs: 'Có cảnh báo trùng mã vận đơn toàn hệ thống, ngăn chặn gian lận & sai sót',
    others: 'Không hỗ trợ hoặc chỉ kiểm tra cục bộ từng máy'
  },
  {
    criterion: '7. Quản lý tập trung & Đồng bộ đa kho',
    ecampmcs: 'Giám sát và đồng bộ đơn hàng trên nhiều kho khác nhau qua 1 giao diện',
    others: 'Rời rạc từng máy, không có giao diện quản trị tập trung'
  },
  {
    criterion: '8. Thống kê KPI nhân sự đóng gói',
    ecampmcs: 'Tự động thống kê số lượng đơn và thời gian thao tác của từng nhân viên',
    others: 'Không hỗ trợ hoặc phải xuất báo cáo thủ công'
  },
  {
    criterion: '9. Tích hợp lưu trữ đám mây (Cloud)',
    ecampmcs: 'Hỗ trợ kết nối Amazon S3 chủ động chỉ khi khách hàng có yêu cầu',
    others: 'Tự động đồng bộ lên Cloud gây tốn băng thông và phí duy trì'
  },
  {
    criterion: '10. Cơ chế tính phí & Giới hạn video/lưu trữ',
    ecampmcs: 'Tính theo đầu máy tính — Không giới hạn số bàn, số video, thời lượng video và thời hạn lưu',
    others: 'Tính phí lũy tiến theo từng bàn, số lượng đơn hàng hoặc giới hạn ngày lưu trữ'
  }
];

export const ecampmcsFaqs: FaqItem[] = [
  {
    q: '1. Tôi có thể sử dụng máy quét mã vạch có sẵn tại kho được không?',
    a: 'Hoàn toàn được. Nếu 1 máy tính dùng cho 1 bàn đóng hàng thì máy quét mã vạch của bất kỳ hãng nào cũng tương thích. Nếu 1 máy tính kết nối nhiều bàn đóng hàng, PMCS TECH khuyến nghị sử dụng dòng máy quét mã vạch 2D có hỗ trợ cấu hình hậu tố (Suffix) để phân biệt chính xác từng bàn.'
  },
  {
    q: '2. Phần mềm ECAMPMCS có sử dụng được với hệ thống camera có sẵn không?',
    a: 'Phần mềm hỗ trợ tất cả các dòng Camera IP có chuẩn giao thức RTSP. Tuy nhiên, để đảm bảo độ nét của mã vận đơn và tính ổn định cao nhất khi chạy đồng thời nhiều luồng video, chúng tôi khuyến nghị sử dụng dòng camera chuyên dụng do PMCS TECH chỉ định.'
  },
  {
    q: '3. Không dùng máy quét mã vạch mà quét bằng Camera luôn có được không?',
    a: 'Được. Phần mềm ECAMPMCS (gói 1 bàn chỉ 3.000.000 ₫/năm và gói ECAM Extend từ 2 bàn trở lên 5.000.000 ₫/năm/máy tính) đều hỗ trợ nhận diện mã QR trực tiếp qua ống kính camera (khoanh vùng AI ROI) mà không cần máy quét rời. Với kho có sản lượng lớn hoặc nhiều bàn đóng gói, trang bị thêm máy quét 2D chuyên dụng sẽ giúp tốc độ thao tác nhanh hơn và giảm tải CPU.'
  },
  {
    q: '4. PMCS TECH có hỗ trợ khảo sát và lắp đặt tận nơi không?',
    a: 'Tại khu vực TP. Hồ Chí Minh, kỹ thuật viên PMCS TECH hỗ trợ lắp đặt tận nơi với chi phí 300.000đ/bàn đóng hàng, và MIỄN PHÍ 100% chi phí lắp đặt khi khách hàng triển khai từ 3 bàn đóng hàng trở lên.'
  },
  {
    q: '5. Giá phần mềm tính theo bàn hay theo máy tính? Có giới hạn số bàn, số video hay thời gian lưu không?',
    a: 'Giá phần mềm tính theo ĐẦU MÁY TÍNH (chỉ 3.000.000 ₫/năm cho 1 bàn đóng hàng, gói ECAM Extend 5.000.000 ₫/năm/máy tính khi triển khai từ 2 bàn trở lên). Mỗi máy tính KHÔNG GIỚI HẠN số bàn đóng gói (phụ thuộc cấu hình phần cứng máy tính; ví dụ CPU Core i3-14100 chạy mượt 5–8 bàn / 10–16 camera), KHÔNG GIỚI HẠN số lượng video, thời lượng video và thời hạn lưu trữ.'
  },
  {
    q: '6. Kho hàng của tôi ở tỉnh xa thì có thể tự lắp đặt và cài đặt được không?',
    a: 'Hoàn toàn được. Hệ thống được thiết kế tối giản, đội ngũ kỹ thuật PMCS TECH sẽ hướng dẫn lắp đặt qua Video Call/Zalo và trực tiếp cấu hình phần mềm từ xa qua UltraViewer trong vòng 15–30 phút.'
  },
  {
    q: '7. Chính sách bảo hành đối với phần mềm và thiết bị phần cứng như thế nào?',
    a: 'Phần mềm ECAMPMCS được bảo hành và hỗ trợ kỹ thuật xuyên suốt thời hạn bản quyền. Toàn bộ thiết bị máy quét mã vạch, camera và phụ kiện đều được nhập khẩu chính ngạch, đầy đủ CO/CQ và bảo hành chính hãng từ 12–24 tháng.'
  }
];

export const contactFaqs: FaqItem[] = [
  {
    q: '1. Làm thế nào để liên hệ nhận báo giá và hỗ trợ nhanh nhất?',
    a: 'Quý khách có thể gọi trực tiếp Hotline Kinh doanh 0911.338.893, Hotline Kỹ thuật 0969.678.988 hoặc nhắn tin qua Zalo OA của PMCS TECH để nhận phản hồi tức thì.'
  },
  {
    q: '2. Tôi có thể đến trực tiếp văn phòng để xem demo thiết bị và phần mềm không?',
    a: 'Có. Quý khách có thể đến Trụ sở chính tại Tầng 19, Indochina Park Tower, Số 4 Nguyễn Đình Chiểu, Quận 1 hoặc Phòng Trải Nghiệm & Demo (Demo Room) tại Đường 14, Khu Đô Thị Vạn Phúc, P. Hiệp Bình Phước, TP. Thủ Đức, TP.HCM.'
  },
  {
    q: '3. PMCS TECH có hỗ trợ giao hàng và xuất hóa đơn VAT toàn quốc không?',
    a: 'PMCS TECH hỗ trợ giao hàng miễn phí trên toàn quốc, cung cấp đầy đủ giấy chứng nhận xuất xứ/chất lượng (CO/CQ), giấy chứng nhận bản quyền phần mềm ECAMPMCS và xuất hóa đơn GTGT (VAT) hợp lệ cho doanh nghiệp.'
  },
  {
    q: '4. Thời gian làm việc và hỗ trợ kỹ thuật ngoài giờ hành chính ra sao?',
    a: 'Giờ làm việc chính thức từ Thứ 2 – Thứ 6 (08:00 – 17:00) và Thứ 7 (08:00 – 12:00). Trong các trường hợp khẩn cấp ngoài giờ hành chính, quý khách nhắn tin qua Zalo 0911.338.893 sẽ được kỹ sư trực hệ thống hỗ trợ kịp thời.'
  }
];

// Exact 12 WoodMart Brand Logos (THƯƠNG HIỆU ƯA CHUỘNG)
export const partnerBrands = [
  { name: 'Opticon', logo: '/wp-content/uploads/2025/02/Opticon-logo.jpg' },
  { name: 'Zebra', logo: '/wp-content/uploads/2025/02/Zebra-Logo.jpg' },
  { name: 'Chainway', logo: '/wp-content/uploads/2025/02/Chainway-Logo.jpg' },
  { name: 'Honeywell', logo: '/wp-content/uploads/2025/02/Honeywell-Logo.png' },
  { name: 'Datalogic', logo: '/wp-content/uploads/2025/02/Logo-datalogic.png' },
  { name: 'CipherLab', logo: '/wp-content/uploads/2025/02/Logo-cipherlab.png' },
  { name: 'Impinj', logo: '/wp-content/uploads/2025/02/Logo-impinj.png' },
  { name: 'SATO', logo: '/wp-content/uploads/2025/02/Logo-sato.png' },
  { name: 'Unitech', logo: '/wp-content/uploads/2025/02/Logo-unitech.png' },
  { name: 'Syble', logo: '/wp-content/uploads/2025/02/Syble-Logo.jpg' },
  { name: 'Newland', logo: '/wp-content/uploads/2025/02/logo-newland.png' },
  { name: 'Intermec', logo: '/wp-content/uploads/2025/02/logo-intermec.png' }
];

// Exact 8 WoodMart Market Application Promo Banners (THỊ TRƯỜNG ỨNG DỤNG - 2 rows of 4)
export const industrySolutions = [
  {
    title: 'Logistics',
    desc: 'Quét mã vận đơn tốc độ cao, đối soát luồng hàng hóa và tự động hóa trạm phân loại.',
    image: '/wp-content/uploads/2025/02/logistics.jpg',
    path: '/product-category/thiet-bi-ma-vach/'
  },
  {
    title: 'Bán Lẻ',
    desc: 'Quay video đóng gói ECAMPMCS chống tráo hàng, thiết bị POS siêu thị và cửa hàng.',
    image: '/wp-content/uploads/2025/02/close-up-of-the-sellers-hands-in-gloves-shows-the-538ZKDG.jpg',
    path: '/product/phan-mem-quay-video-dong-hang-ecampmcs/'
  },
  {
    title: 'Y Tế',
    desc: 'Định danh bệnh phẩm, quản lý hồ sơ bệnh án, thuốc và trang thiết bị bệnh viện.',
    image: '/wp-content/uploads/2025/02/IMG_1722.jpg',
    path: '/cong-nghe-ma-vach/'
  },
  {
    title: 'Quản Lý Kho',
    desc: 'Kiểm kê kho tự động bằng máy kiểm kho PDA Android và công nghệ sóng UHF RFID.',
    image: '/wp-content/uploads/2025/02/d16ff3f2-80da-456c-8051-3b05bcdf.jpg',
    path: '/product-category/thiet-bi-ma-vach/may-kiem-kho/'
  },
  {
    title: 'Quản Lý Tài Sản',
    desc: 'Định danh và theo dõi tài sản cố định, thiết bị CNTT, nữ trang bằng tem nhãn RFID.',
    image: '/wp-content/uploads/2025/02/8dd28ecc-7e4e-4e1b-84a6-c6e53cf6.jpg',
    path: '/cong-nghe-rfid/'
  },
  {
    title: 'Dịch Vụ',
    desc: 'Giải pháp check-in khách sạn, sự kiện và bộ quà tặng công nghệ khắc Logo LED VIP.',
    image: '/wp-content/uploads/2025/02/young-hotel-receptionists-looking-at-colleague-wit-4T9QXY9-768x512.jpg',
    path: '/product-category/phu-kien-cong-nghe/set-qua-tang-cong-nghe/'
  },
  {
    title: 'Giáo Dục',
    desc: 'Quản lý thư viện thông minh, mượn trả sách tự động và định danh thẻ học sinh/sinh viên.',
    image: '/wp-content/uploads/2025/02/ung-dung-ma-vach-trong-giao-duc.jpg',
    path: '/cong-nghe-ma-vach/'
  },
  {
    title: 'Nông Nghiệp',
    desc: 'Truy xuất nguồn gốc nông sản xuất khẩu, quản lý mã số vùng trồng và chuỗi cung ứng lạnh.',
    image: '/wp-content/uploads/2025/02/ung-dung-ma-vach-trong-nong-nghiep.jpg',
    path: '/thi-truong/'
  }
];

export const homepageVideos = [
  {
    id: 'cmEJiLL5Cxk',
    title: 'Phần Mềm Kiểm Kho RFID cho Nữ Trang',
    thumbnail: '/wp-content/uploads/2025/02/z2276664238717_3e88b761b30c6cb5d3e6d00f624a21de.jpg',
    youtubeId: 'cmEJiLL5Cxk'
  },
  {
    id: 'w1C-gddiAk8',
    title: 'Phần Mềm Quay Video Đóng Hàng ECAMPMCS',
    thumbnail: '/wp-content/uploads/2025/02/phan-mem-quay-video-dong-goi-hang-hoa-e1746798940108.jpg',
    youtubeId: 'w1C-gddiAk8'
  },
  {
    id: 'aO5zmCWUuB0',
    title: 'Phần Mềm Kiểm Kho RFID Sử dụng Excel',
    thumbnail: '/wp-content/uploads/2025/02/IMG_3436.jpg',
    youtubeId: 'aO5zmCWUuB0'
  },
  {
    id: 'WHY1WcF5AyE',
    title: 'Máy đọc mã vạch QR CCCD & mã vạch Passport',
    thumbnail: '/wp-content/uploads/2025/02/may-doc-ma-vach-passport-opticon-pr-11-mau-trang-010.jpg',
    youtubeId: 'WHY1WcF5AyE'
  }
];

export interface EcampmcsScreenshotItem {
  id: string;
  src: string;
  badge: string;
  title: string;
  alt: string;
  desc: string;
}

export interface EcampmcsVideoTutorialItem {
  id: string;
  src: string;
  poster: string;
  step: string;
  title: string;
  desc: string;
  duration: string;
}

// 17 Giao diện Quản trị Thực tế Phần mềm Ghi hình Đóng hàng ECAMPMCS v12 (ASCAM v12)
export const ecampmcsV12Screenshots: EcampmcsScreenshotItem[] = [
  {
    id: 'page_tructiep',
    src: '/wp-content/uploads/2025/10/giao-dien-xem-truc-tiep-da-camera-ai-qr-ecampmcs-v12.webp',
    badge: '01 • Giám Sát Trực Tiếp',
    title: 'Giao diện Xem Trực Tiếp Đa Camera WHEP & Khung Xanh AI Nhận Diện QR',
    alt: 'Giao diện xem trực tiếp đa camera WHEP nhận diện mã QR bằng AI phần mềm quay video đóng hàng ECAMPMCS v12',
    desc: 'Giám sát đồng thời toàn bộ bàn đóng gói theo thời gian thực với độ trễ dưới 200ms, hiển thị khung xanh AI bắt mã vận đơn QR/Barcode tự động và trạng thái đang ghi hình (REC) từng bàn.'
  },
  {
    id: 'page_tracuu',
    src: '/wp-content/uploads/2025/10/giao-dien-tra-cuu-video-dong-hang-2-goc-ecampmcs-v12.webp',
    badge: '02 • Tra Cứu 2 Góc Quay',
    title: 'Giao diện Tra Cứu Video Đơn Hàng 3 Giây & Xem Song Song 2 Góc Camera',
    alt: 'Giao diện tra cứu video đóng hàng 3 giây xem song song 2 góc camera toàn cảnh và soi mã vận đơn',
    desc: 'Tìm kiếm tức thì theo mã vận đơn, phát đồng thời góc Camera Toàn Cảnh và Camera Soi Mã Vận Đơn, hỗ trợ trích xuất hàng loạt và tạo đường link chia sẻ Cloud 1-Click gửi sàn TMĐT.'
  },
  {
    id: 'page_timeline',
    src: '/wp-content/uploads/2025/10/giao-dien-timeline-ghi-hinh-247-cat-video-ecampmcs-v12.webp',
    badge: '03 • Timeline 24/7',
    title: 'Giao diện Dải Băng Thời Gian (Timeline 24/7) & Chỉnh Sửa Độ Dài Video',
    alt: 'Giao diện timeline ghi hình liên tục 24/7 và kéo thả cắt chỉnh sửa độ dài video đóng hàng',
    desc: 'Tua lại lịch sử ghi hình liên tục 24/7 tại bàn đóng gói, kéo thả thanh trượt trực quan để điều chỉnh điểm bắt đầu và điểm kết thúc video đơn hàng khi cần trích xuất đoạn bằng chứng dài hơn.'
  },
  {
    id: 'page_cameraRoi_config',
    src: '/wp-content/uploads/2025/10/giao-dien-cau-hinh-vung-quet-roi-soi-van-don-ecampmcs-v12.webp',
    badge: '04 • Khoanh Vùng AI ROI',
    title: 'Giao diện Khoanh Vùng Quét ROI (Region of Interest) Trên Camera Soi Vận Đơn',
    alt: 'Giao diện cấu hình khoanh vùng quét ROI soi mã vận đơn tự động bằng AI trên phần mềm ghi hình đóng hàng',
    desc: 'Kéo thả vùng nhận diện (ROI) tại đúng vị trí đặt phiếu gửi hàng để thuật toán AI tập trung giải mã QR/Barcode siêu tốc trong 0.2 giây và giảm tới 60% tải CPU máy tính.'
  },
  {
    id: 'page_camera',
    src: '/wp-content/uploads/2025/10/giao-dien-quan-ly-ban-dong-goi-camera-rtsp-ecampmcs-v12.webp',
    badge: '05 • Quản Trị Camera RTSP',
    title: 'Giao diện Quản Trị Bàn Đóng Gói & Chẩn Đoán Sức Khỏe Mạng Camera RTSP',
    alt: 'Giao diện quản lý bàn đóng gói cấu hình luồng RTSP và chẩn đoán mạng camera Bitrate Latency Jitter',
    desc: 'Cấu hình tới 8 luồng camera RTSP/bàn (Luồng chính ghi hình HD + Luồng phụ AI), áp dụng cấu hình nóng không gián đoạn và đo Bitrate, Latency, Jitter, Packet Loss thời gian thực.'
  },
  {
    id: 'page_thongke',
    src: '/wp-content/uploads/2025/10/giao-dien-thong-ke-kpi-bieu-do-san-luong-ecampmcs-v12.webp',
    badge: '06 • Thống Kê & Heatmap',
    title: 'Giao diện Thống Kê Sản Lượng Đóng Gói, Biểu Đồ Giờ Cao Điểm & Heatmap',
    alt: 'Giao diện báo cáo thống kê sản lượng KPI biểu đồ giờ cao điểm và bản đồ nhiệt Heatmap kho hàng',
    desc: 'Báo cáo trực quan tổng số đơn đóng gói, thời gian đóng trung bình (giây/đơn), tỷ lệ đọc mã QR tự động và bản đồ nhiệt (Heatmap) phân bổ mật độ làm việc theo từng khung giờ.'
  },
  {
    id: 'page_bangxephang',
    src: '/wp-content/uploads/2025/10/giao-dien-bang-xep-hang-kpi-nhan-vien-dong-goi-ecampmcs-v12.webp',
    badge: '07 • Bảng Xếp Hạng KPI',
    title: 'Giao diện Bảng Xếp Hạng Năng Suất KPI Nhân Viên Đóng Gói Minh Bạch',
    alt: 'Giao diện bảng xếp hạng KPI năng suất nhân viên đóng gói đơn hàng theo ca làm việc',
    desc: 'Tự động xếp hạng nhân sự kho theo tổng số đơn hoàn thành, tốc độ đóng gói trung bình và tỷ lệ chuẩn xác để làm cơ sở tính lương thưởng KPI công bằng.'
  },
  {
    id: 'page_xuatdulieu',
    src: '/wp-content/uploads/2025/10/giao-dien-xuat-du-lieu-bao-cao-excel-ecampmcs-v12.webp',
    badge: '08 • Xuất Báo Cáo Excel',
    title: 'Giao diện Xuất Dữ Liệu Đối Soát Excel/CSV & Báo Cáo Kiểm Toán Kho',
    alt: 'Giao diện xuất dữ liệu báo cáo đối soát đơn hàng ra file Excel CSV kèm link video bằng chứng',
    desc: 'Trích xuất toàn bộ danh sách mã vận đơn, thời gian đóng gói, bàn thực hiện, nhân viên phụ trách và đường link video bằng chứng ra file Excel phục vụ kế toán và đối soát sàn.'
  },
  {
    id: 'page_aborted_billcode',
    src: '/wp-content/uploads/2025/10/giao-dien-canh-bao-don-huy-don-trung-ecampmcs-v12.webp',
    badge: '09 • Chặn Đơn Hủy & Trùng',
    title: 'Giao diện Quản Lý & Cảnh Báo Giọng Nói AI Khi Quét Đơn Hủy / Đơn Đóng Trùng',
    alt: 'Giao diện cảnh báo giọng nói tiếng Việt khi quét trúng đơn hàng khách hủy hoặc đơn đóng trùng lặp',
    desc: 'Nhập danh sách mã vận đơn khách vừa bấm hủy trên sàn; phần mềm lập tức phát loa cảnh báo giọng nói tiếng Việt và chặn đóng gói khi nhân viên quét trúng đơn hủy hoặc đơn trùng.'
  },
  {
    id: 'page_command_codes',
    src: '/wp-content/uploads/2025/10/giao-dien-the-ma-lenh-qr-hoan-hang-ban-giao-ecampmcs-v12.webp',
    badge: '10 • Thẻ Mã Lệnh QR',
    title: 'Giao diện Bộ Thẻ Mã Lệnh QR Điều Khiển Nhanh (Đóng Gói, Hoàn Hàng, Bàn Giao)',
    alt: 'Giao diện bộ thẻ mã lệnh QR chuyển chế độ đóng gói khui hàng hoàn và bàn giao vận chuyển',
    desc: 'Cung cấp bộ mã lệnh QR in sẵn dán tại bàn giúp nhân viên chuyển đổi tức thì giữa các chế độ: Đóng hàng mới, Khui kiểm hàng hoàn (Return), Bàn giao bưu tá và Xuất kho sỉ.'
  },
  {
    id: 'page_staff',
    src: '/wp-content/uploads/2025/10/giao-dien-quan-ly-nhan-vien-the-qr-diem-danh-ecampmcs-v12.webp',
    badge: '11 • Hồ Sơ Nhân Sự & QR',
    title: 'Giao diện Quản Lý Nhân Viên Đóng Hàng & Cấp Phát Thẻ QR Định Danh Đầu Ca',
    alt: 'Giao diện quản lý hồ sơ nhân viên đóng gói và in thẻ QR định danh điểm danh đầu ca',
    desc: 'Tạo hồ sơ nhân viên kho và xuất thẻ QR cá nhân để nhân viên quét điểm danh nhận bàn đóng gói đầu ca làm việc chỉ trong 1 giây.'
  },
  {
    id: 'page_account',
    src: '/wp-content/uploads/2025/10/giao-dien-quan-ly-tai-khoan-nguoi-dung-ecampmcs-v12.webp',
    badge: '12 • Quản Lý Tài Khoản',
    title: 'Giao diện Danh Sách Tài Khoản Quản Trị, Quản Lý Kho & CSKH',
    alt: 'Giao diện quản lý danh sách tài khoản người dùng quản trị viên và nhân viên CSKH',
    desc: 'Quản lý tập trung toàn bộ tài khoản truy cập hệ thống, trạng thái hoạt động, nhóm quyền hạn và phạm vi bàn đóng gói được phép giám sát.'
  },
  {
    id: 'page_account_newaccount',
    src: '/wp-content/uploads/2025/10/giao-dien-tao-tai-khoan-moi-phan-ban-ecampmcs-v12.webp',
    badge: '13 • Cấp Tài Khoản Theo Bàn',
    title: 'Giao diện Khởi Tạo Tài Khoản Mới & Phân Quyền Giám Sát Đến Từng Bàn Đóng Gói',
    alt: 'Giao diện tạo tài khoản mới và giới hạn quyền truy cập theo từng bàn đóng gói cụ thể',
    desc: 'Thiết lập tài khoản riêng cho nhân viên CSKH hoặc Trưởng ca, cho phép giới hạn quyền xem và trích xuất video chỉ trên những bàn đóng gói được chỉ định.'
  },
  {
    id: 'page_account_newgroup_permission',
    src: '/wp-content/uploads/2025/10/giao-dien-phan-quyen-rbac-nhom-tai-khoan-ecampmcs-v12.webp',
    badge: '14 • Ma Trận Quyền RBAC',
    title: 'Giao diện Phân Quyền Bảo Mật RBAC Chi Tiết Hơn 16 Tác Vụ Quản Trị Kho',
    alt: 'Giao diện phân quyền bảo mật RBAC 16 tác vụ chi tiết cho nhóm tài khoản quản lý kho',
    desc: 'Kiểm soát chặt chẽ từng quyền hạn: Xem trực tiếp, Tra cứu video, Xóa dữ liệu, Xuất báo cáo, Cấu hình camera, Quản lý License nhằm bảo mật tuyệt đối dữ liệu doanh nghiệp.'
  },
  {
    id: 'page_lienketkho',
    src: '/wp-content/uploads/2025/10/giao-dien-lien-ket-da-kho-p2p-mesh-ecampmcs-v12.webp',
    badge: '15 • Liên Kết Đa Kho P2P',
    title: 'Giao diện Mạng Lưới Liên Kết Đa Kho P2P Mesh Xuyên Chi Nhánh',
    alt: 'Giao diện cấu hình liên kết đa kho P2P Mesh tra cứu video xuyên chi nhánh không cần mở port',
    desc: 'Kết nối nhiều kho hàng trên toàn quốc thành một mạng lưới thống nhất mà không cần mở Port Modem hay thuê IP tĩnh, giúp tra cứu và chia sẻ video xuyên chi nhánh tức thì.'
  },
  {
    id: 'page_quantri',
    src: '/wp-content/uploads/2025/10/giao-dien-quan-tri-he-thong-tham-so-luu-tru-ecampmcs-v12.webp',
    badge: '16 • Tham Số & Ổ Cứng',
    title: 'Giao diện Quản Trị Tham Số Hệ Thống, Đóng Dấu OSD & Tự Động Dọn Ổ Cứng',
    alt: 'Giao diện quản trị hệ thống cấu hình đóng dấu Watermark OSD và tự động dọn dẹp ổ cứng',
    desc: 'Tùy chỉnh thời lượng ghi hình tối đa, nội dung lớp phủ Watermark/OSD, chu kỳ tự động xóa xoay vòng video cũ khi đầy ổ cứng và cấu hình Webhook/Open API.'
  },
  {
    id: 'page_license',
    src: '/wp-content/uploads/2025/10/giao-dien-quan-ly-ban-quyen-license-ecampmcs-v12.webp',
    badge: '17 • Quản Lý License',
    title: 'Giao diện Quản Lý Bản Quyền Phần Mềm (License Key) & Định Danh Thiết Bị',
    alt: 'Giao diện quản lý bản quyền phần mềm License Key ECAMPMCS v12 chính hãng',
    desc: 'Theo dõi minh bạch gói bản quyền đang kích hoạt, thời hạn sử dụng, số lượng camera/bàn đóng gói tối đa và hỗ trợ nâng cấp gói linh hoạt từ xa.'
  }
];

// 13 Video Hướng dẫn Thao tác & Vận hành Thực tế Phần mềm Ghi hình Đóng hàng v12
export const ecampmcsV12Videos: EcampmcsVideoTutorialItem[] = [
  {
    id: 'vid-tong-quan-v12',
    src: '/wp-content/uploads/2025/10/video-tong-quan-phan-mem-ghi-hinh-dong-hang-ecampmcs-v12.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-xem-truc-tiep-da-camera-ai-qr-ecampmcs-v12.webp',
    step: 'Video 01 • Tổng Quan Hệ Thống',
    title: 'Tổng quan Kiến trúc & Vận hành Phần mềm Ghi hình Đóng hàng ECAMPMCS v12',
    desc: 'Trải nghiệm toàn diện quy trình giám sát đa luồng camera, tự động bắt mã vận đơn QR/Barcode bằng AI, đóng dấu Timestamp và quản trị tập trung trên 1 màn hình.',
    duration: 'PT1M35S'
  },
  {
    id: 'vid-cac-tinh-nang-v12',
    src: '/wp-content/uploads/2025/10/video-cac-tinh-nang-phan-mem-quay-video-dong-hang-v12.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-thong-ke-kpi-bieu-do-san-luong-ecampmcs-v12.webp',
    step: 'Video 02 • Điểm Nhấn Tính Năng',
    title: 'Điểm qua Các Tính Năng Đột Phá Trên Phần Mềm Quay Video Đóng Hàng v12',
    desc: 'Giới thiệu nhanh hệ thống Dashboard thống kê sản lượng KPI, bảng xếp hạng nhân viên, cảnh báo đơn hủy/đơn trùng và quản lý đa kho.',
    duration: 'PT1M15S'
  },
  {
    id: 'vid-tao-mat-khau-lan-dau',
    src: '/wp-content/uploads/2025/10/video-tao-mat-khau-quan-tri-vien-lan-dau.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-quan-tri-he-thong-tham-so-luu-tru-ecampmcs-v12.webp',
    step: 'Video 03 • Khởi Tạo Bảo Mật',
    title: 'Hướng dẫn Thiết lập Mật khẩu Quản trị viên (Admin) Lần đầu Khi Mới Cài Đặt',
    desc: 'Thao tác khởi tạo mật khẩu bảo mật hệ thống quản trị ngay sau khi cài đặt phần mềm quay video đóng hàng trên máy tính trung tâm.',
    duration: 'PT0M22S'
  },
  {
    id: 'vid-khoanh-vung-roi',
    src: '/wp-content/uploads/2025/10/video-khoanh-vung-roi-camera-soi-van-don-ai.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-cau-hinh-vung-quet-roi-soi-van-don-ecampmcs-v12.webp',
    step: 'Video 04 • Khoanh Vùng AI ROI',
    title: 'Hướng dẫn Khoanh vùng ROI Trên Camera Soi Mã Vận Đơn (SVD) Bằng AI',
    desc: 'Cách kéo thả vùng nhận diện (Region of Interest) tại đúng vị trí đặt phiếu gửi hàng để AI đọc mã QR/Barcode siêu tốc và chống nhận diện nhầm.',
    duration: 'PT1M20S'
  },
  {
    id: 'vid-tao-nhan-vien-qr',
    src: '/wp-content/uploads/2025/10/video-tao-nhan-vien-dong-hang-va-in-the-qr.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-quan-ly-nhan-vien-the-qr-diem-danh-ecampmcs-v12.webp',
    step: 'Video 05 • Hồ Sơ & Thẻ QR',
    title: 'Hướng dẫn Tạo Nhân viên Đóng hàng & Xuất Thẻ QR Định danh Cá nhân',
    desc: 'Thêm nhân sự đóng gói mới vào hệ thống và in thẻ mã QR định danh để theo dõi sản lượng KPI cá nhân chính xác theo từng ca làm việc.',
    duration: 'PT0M45S'
  },
  {
    id: 'vid-momaqr-dang-nhap',
    src: '/wp-content/uploads/2025/10/video-quet-ma-momaqr-dang-nhap-nhan-ban-dong-goi.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-the-ma-lenh-qr-hoan-hang-ban-giao-ecampmcs-v12.webp',
    step: 'Video 06 • Điểm Danh Nhận Bàn',
    title: 'Hướng dẫn Cấp quyền Thông báo & Quét Mã MomaQR Đăng nhập Nhận Bàn Đóng Gói',
    desc: 'Nhân viên bật thông báo trình duyệt và đưa thẻ QR vào camera để đăng nhập nhận bàn đóng gói tức thì mà không cần nhập mật khẩu thủ công.',
    duration: 'PT0M25S'
  },
  {
    id: 'vid-phan-quyen-rbac',
    src: '/wp-content/uploads/2025/10/video-tao-nhom-quyen-rbac-va-tai-khoan-nhan-vien.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-phan-quyen-rbac-nhom-tai-khoan-ecampmcs-v12.webp',
    step: 'Video 07 • Phân Quyền RBAC',
    title: 'Hướng dẫn Tạo Nhóm Quyền Bảo mật RBAC & Cấp Tài khoản Theo Bàn Đóng Gói',
    desc: 'Thiết lập nhóm quyền chi tiết (Admin, Quản lý kho, CSKH, Nhân viên) và giới hạn quyền truy cập dữ liệu đến từng bàn đóng gói cụ thể.',
    duration: 'PT1M10S'
  },
  {
    id: 'vid-xem-lai-tung-goc',
    src: '/wp-content/uploads/2025/10/video-xem-lai-video-dong-hang-tung-goc-camera.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-tra-cuu-video-dong-hang-2-goc-ecampmcs-v12.webp',
    step: 'Video 08 • Xem 2 Góc Camera',
    title: 'Hướng dẫn Tra cứu 3 Giây & Xem Lại Video Đơn Hàng Theo Từng Góc Camera',
    desc: 'Nhập mã vận đơn để phát song song hoặc chuyển đổi mượt mà giữa góc Camera Toàn Cảnh đóng gói và góc Camera Cận Cảnh soi mã vận đơn.',
    duration: 'PT0M35S'
  },
  {
    id: 'vid-cat-video-timeline',
    src: '/wp-content/uploads/2025/10/video-chinh-sua-do-dai-cat-video-tren-timeline.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-timeline-ghi-hinh-247-cat-video-ecampmcs-v12.webp',
    step: 'Video 09 • Cắt Chỉnh Timeline',
    title: 'Hướng dẫn Cắt & Chỉnh sửa Độ dài Video Đơn hàng Trực quan Trên Timeline',
    desc: 'Kéo thanh trượt điều chỉnh thời điểm bắt đầu và kết thúc của video đơn hàng trên dải băng ghi hình 24/7 khi cần trích xuất đoạn bằng chứng dài hơn.',
    duration: 'PT1M30S'
  },
  {
    id: 'vid-gop-hang-loat',
    src: '/wp-content/uploads/2025/10/video-gop-2-goc-quay-tai-video-hang-loat.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-xuat-du-lieu-bao-cao-excel-ecampmcs-v12.webp',
    step: 'Video 10 • Gộp Video Hàng Loạt',
    title: 'Hướng dẫn Gộp 2 Góc Quay (Picture-in-Picture) & Tải Video Bằng Chứng Hàng Loạt',
    desc: 'Chọn nhiều đơn hàng cùng lúc, tự động ghép góc toàn cảnh + góc soi vận đơn bằng tăng tốc phần cứng GPU và tải về máy nhanh chóng.',
    duration: 'PT1M05S'
  },
  {
    id: 'vid-chia-se-cloud-don-le',
    src: '/wp-content/uploads/2025/10/video-chia-se-link-video-don-hang-public-cloud.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-tra-cuu-video-dong-hang-2-goc-ecampmcs-v12.webp',
    step: 'Video 11 • Chia Sẻ Cloud 1-Click',
    title: 'Hướng dẫn Chia sẻ Link Video Đơn Hàng Lên Public Cloud Chỉ Với 1 Cú Nhấp Chuột',
    desc: 'Đồng bộ tức thì video bằng chứng lên đám mây và sao chép đường link rút gọn gửi trực tiếp cho Shopee, TikTok Shop, Lazada hoặc khách mua hàng.',
    duration: 'PT0M42S'
  },
  {
    id: 'vid-chia-se-cloud-hang-loat',
    src: '/wp-content/uploads/2025/10/video-chia-se-hang-loat-video-len-public-cloud.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-xuat-du-lieu-bao-cao-excel-ecampmcs-v12.webp',
    step: 'Video 12 • Chia Sẻ Cloud Hàng Loạt',
    title: 'Hướng dẫn Đồng bộ & Chia sẻ Hàng Loạt Video Khiếu Nại Lên Đám Mây Public Cloud',
    desc: 'Chọn danh sách nhiều đơn hàng khiếu nại và đẩy đồng loạt lên đám mây để xuất danh sách link bằng chứng phục vụ đối soát tập trung.',
    duration: 'PT1M02S'
  },
  {
    id: 'vid-lien-ket-p2p-mesh',
    src: '/wp-content/uploads/2025/10/video-chia-se-video-lien-ket-da-kho-p2p-mesh.mp4',
    poster: '/wp-content/uploads/2025/10/giao-dien-lien-ket-da-kho-p2p-mesh-ecampmcs-v12.webp',
    step: 'Video 13 • Liên Kết Đa Kho P2P',
    title: 'Hướng dẫn Liên kết Đa kho P2P Mesh & Chia sẻ Video Nội bộ Xuyên Chi Nhánh',
    desc: 'Thiết lập mã kết nối P2P Mesh giữa các kho hàng ở nhiều tỉnh thành để bộ phận CSKH trung tâm tra cứu và xem video đơn hàng xuyên chuỗi kho.',
    duration: 'PT0M38S'
  }
];

// Hệ sinh thái Liên kết Tăng Sức Mạnh SEO cho Trang Chính ghihinh.com & Các Chuyên Trang Vệ Tinh
export const ghihinhEcosystemLinks = [
  {
    url: 'https://ghihinh.com/',
    anchor: 'Phần mềm quay video đóng hàng & Ghi hình đóng gói — Ghihinh.com',
    desc: 'Chuyên trang trụ cột về phần mềm quay video đóng hàng ASCAM Enterprise / ECAM (chỉ 3 triệu/năm cho 1 bàn, tính theo đầu máy tính không giới hạn số bàn & số video).'
  },
  {
    url: 'https://ghihinh.com/camera-dong-hang-shopee-tiktok-tiki-lazada/',
    anchor: 'Camera đóng hàng Shopee, TikTok Shop, Lazada',
    desc: 'Giải pháp lắp đặt trọn bộ 2 camera đóng gói (toàn cảnh + soi mã vận đơn) đạt chuẩn xử lý khiếu nại sàn TMĐT.'
  },
  {
    url: 'https://ghihinh.com/camera-soi-van-don/',
    anchor: 'Camera soi mã vận đơn & Quét QR tự động',
    desc: 'Thiết bị camera chuyên dụng đọc mã vận đơn QR/Barcode tự động không cần máy quét cầm tay.'
  },
  {
    url: 'https://ghihinh.com/huong-dan-quay-video-dong-hang/',
    anchor: 'Hướng dẫn quay video đóng hàng chuẩn sàn TMĐT',
    desc: 'Quy trình 7 bước quay video đóng gói hàng hóa giúp nhà bán hàng thắng trên 95% tranh chấp hoàn hàng.'
  },
  {
    url: 'https://ghihinh.com/so-sanh-phan-mem-quay-video-dong-hang/',
    anchor: 'So sánh phần mềm quay video đóng hàng 2026',
    desc: 'Bảng đối chiếu chi tiết tính năng, kiến trúc lưu trữ và chi phí của các giải pháp ghi hình đóng gói hiện nay.'
  },
  {
    url: 'https://quayvideo.com/',
    anchor: 'Quay video đóng hàng tự động — Quayvideo.com',
    desc: 'Cẩm nang kỹ thuật thiết lập trạm quay video đóng gói tự động cho kho Fulfillment và nhà bán hàng đa kênh.'
  },
  {
    url: 'https://videopacking.com/',
    anchor: 'Packing Video Software & Order Recording System — Videopacking.com',
    desc: 'Cổng thông tin quốc tế giải pháp phần mềm ghi hình đóng gói đơn hàng TMĐT (Per-PC Unlimited Licensing từ $120/năm).'
  },
  {
    url: 'https://pmcstech.com/',
    anchor: 'Thiết bị UHF RFID & Máy kiểm kho PDA — Pmcstech.com',
    desc: 'Chuyên trang thiết bị đầu đọc RFID Chainway, máy in RFID và giải pháp quản lý kho tự động của PMCS TECH.'
  },
  {
    url: 'https://rfidlagi.com/',
    anchor: 'Kiến thức & Giải pháp RFID — Rfidlagi.com',
    desc: 'Thư viện kiến thức chuyên sâu về công nghệ nhận dạng tần số vô tuyến RFID và ứng dụng kho vận.'
  }
];

